import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { IconContext } from 'react-icons';
import { RiShareLine } from 'react-icons/ri';

import { useBranding } from '../contexts/branding-context';

const BrandLogo = ({
  compact = false,
  iconSize = '36px',
  className = '',
  imageClassName = '',
}) => {
  const {
    settings: { logoUrl, logoCompactUrl, systemName },
  } = useBranding();

  const logoSource = compact
    ? logoCompactUrl || logoUrl
    : logoUrl || logoCompactUrl;
  const iconContextValue = useMemo(
    () => ({
      size: iconSize,
      color: 'inherit',
    }),
    [iconSize]
  );

  if (logoSource) {
    return (
      <img
        src={logoSource}
        alt={systemName}
        className={imageClassName || className}
      />
    );
  }

  return (
    <span className={className}>
      <IconContext.Provider value={iconContextValue}>
        <RiShareLine />
      </IconContext.Provider>
    </span>
  );
};

BrandLogo.propTypes = {
  compact: PropTypes.bool,
  iconSize: PropTypes.string,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
};

export default BrandLogo;
